import enumeration from "./enumeration";

const BookingSource = {
  MEWS: "MEWS",
  CLOUDBEDS: "CLOUDBEDS",
  TICKETING: "TICKETING",
  EATAPP: "EATAPP",
};

export default enumeration(BookingSource);
